import { render, staticRenderFns } from "./field-type.vue?vue&type=template&id=59b150fe&scoped=true&"
import script from "./field-type.vue?vue&type=script&lang=js&"
export * from "./field-type.vue?vue&type=script&lang=js&"
import style0 from "./field-type.vue?vue&type=style&index=0&id=59b150fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b150fe",
  null
  
)

export default component.exports